import React from 'react';
import './StepsSection.css';

const StepsSection: React.FC = () => {
  return (
    <section className="steps-section">
      <div className="steps-content">
        <h2 className="steps-title">КАЛЕНДАРЬ СОБЫТИЙ</h2>
        
        <div className="step step-1">
          <div className="step-line"></div>
          <div className="step-text">
            <h3>РЕГИСТРАЦИЯ КОМАНД</h3>
            <p>25.05.2026 - 04.10.2026</p>
            <p>Участники регистрируются, заполняя форму здесь</p>
          </div>
        </div>

        <div className="step step-2">
          <div className="step-line"></div>
          <div className="step-text">
            <h3>ТЕОРЕТИЧЕСКИЙ ТУР</h3>
            <p>25.05.2026 - 04.10.2026</p>
          </div>
        </div>

        <div className="step step-3">
          <div className="step-line"></div>
          <div className="step-text">
            <h3>РАЗМЕЩЕНИЕ РЕЗУЛЬТАТОВ ТЕОРЕТИЧЕСКОГО ТУРА И СПИСКА ФИНАЛИСТОВ</h3>
            <p>до 09.10.2026</p>
          </div>
        </div>

        <div className="step step-4">
          <div className="step-line"></div>
          <div className="step-text">
            <h3>ОЧНЫЙ ПРАКТИЧЕСКИЙ ТУР</h3>
            <p>29.10.2026 - 31.10.2026</p>
          </div>
        </div>

        <div className="step step-5">
          <div className="step-line"></div>
          <div className="step-text">
            <h3>ОБЪЯВЛЕНИЕ ПОБЕДИТЕЛЕЙ</h3>
            <p>31.10.2026</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection; 